// @flow
import { TEST_AB } from 'Client/cms/toolkit/constants';
import { TestAB } from './TestAB.jsx';

export const testABDescriptor = {
  name: TEST_AB,
  component: TestAB,
};
